import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { randomString } from '../lib/random-string';
import { sleep } from '../lib/sleep';
import { PICFLOW_CONFIG } from '../picflow-config';
import { DataLoaderService } from './data-loader.service';

@Injectable({
  providedIn: 'root',
})
export class VideoHlsService {
  private http = inject(HttpClient);
  private config = inject(PICFLOW_CONFIG);
  private loader = inject(DataLoaderService);

  public getHlsUrl(uuid: string, original_key: string, width: number, height: number, duration: number) {
    const origin = encodeURIComponent(original_key.replace(uuid + '/', ''));
    return `${this.config.assetsEndpoint}/videos/${uuid}/stream.m3u8?origin=${origin}&width=${width}&height=${height}&duration=${duration}`;
  }

  public getAudioHlsUrl(uuid: string, original_key: string, duration: number) {
    const origin = encodeURIComponent(original_key.replace(uuid + '/', ''));
    const assetType = original_key.split('/' + uuid)[0];
    return `${this.config.assetsEndpoint}/assets/${assetType}/${uuid}/${uuid}-originalaudio.m3u8?origin=${origin}&duration=${duration}`;
  }

  private async loadHlsInternal(url: string, isCancelled: () => boolean) {
    if (isCancelled()) return;
    try {
      const resp = await lastValueFrom(this.http.get(url + '&random=' + randomString(8), { responseType: 'text' }));
      if (resp === 'pending') {
        console.warn("HLS is pending, let's try again in 3 seconds");
        await sleep(3000);
        await this.loadHlsInternal(url, isCancelled);
      }
      return resp;
    } catch (err) {
      console.error(err);
      if (!(err instanceof HttpErrorResponse)) throw err;
      if (err.status !== 404) throw err;
      await sleep(3000);
      this.loadHlsInternal(url, isCancelled);
    }
  }

  public async loadHls(url: string, isCancelled: () => boolean) {
    try {
      return await this.loader.get(url, async () => this.loadHlsInternal(url, isCancelled));
    } catch (err) {
      console.error(err);
    }
  }
}
